import * as React from "react";
import * as ReactDOM from "react-dom";
import styled from "styled-components";
import {spacing} from "../../theme";

// create a portal to an Element to render the cart in
const CartPortal: React.FC<{children?: React.ReactNode}> = (props) => {
  return ReactDOM.createPortal(props.children, document.getElementById("ModalRootElement") as HTMLDivElement);
};

const Modal: React.FC<{
  closeFunction?: (evt: React.MouseEvent<HTMLDivElement>) => void;
  fullScreen?: boolean;
  isVisible: boolean;
}> = (props) => {
  const {children, closeFunction, fullScreen, isVisible} = props;

  React.useEffect(() => {
    const anyModalSection = document.querySelector("#ModalRootElement > section");
    document.body.style.overflow = !!anyModalSection ? "hidden" : "auto";
  });

  if (!isVisible) {
    return null;
  }

  return (
    <CartPortal>
      {!fullScreen && <Backdrop onClick={closeFunction} />}
      <PopUp fullScreen={!!fullScreen}>
        {closeFunction && <CloseButton onClick={closeFunction}>×</CloseButton>}
        {children}
      </PopUp>
    </CartPortal>
  );
};

export default Modal;

const PopupDefault = styled.section.attrs(() => ({onClick: (e) => e.stopPropagation()}))`
  position: fixed;
  display: block;
  top: 0;
  right: 0;
  left: 0;
  color: black;
  background: white;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
  white-space: initial;
  overflow-y: auto;
`;

const PopUpFullScreen = styled(PopupDefault)`
  bottom: 0;
  margin-bottom: 0;
  padding-top: ${() => spacing};
  z-index: 1000;
`;

const PopUpSmall = styled(PopupDefault)`
  max-height: 100vh;
  padding: 20px 40px 34px;
  z-index: 10000;
  @media (min-width: 768px) {
    width: 560px;
    top: 6vh;
    left: 50%;
    margin-left: -280px;
    bottom: inherit;
  }
  > *:last-child {
    margin-bottom: 0;
  }
`;

const PopUp: React.FC<{fullScreen: boolean}> = (props) => {
  if (props.fullScreen) {
    return <PopUpFullScreen>{props.children}</PopUpFullScreen>;
  } else {
    return <PopUpSmall>{props.children}</PopUpSmall>;
  }
};

const Backdrop = styled.div`
  z-index: 5000;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.5);
`;

const CloseButton = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 36px;
  line-height: 0.5;
  color: #888;
  font-weight: bold;
  padding: 12px;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`;
